import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import PolicyTable from './PolicyTable';

const GroupPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Group Policy Automation" dropdown={2} />

        <Card className="flex-1">
          <PolicyTable />
        </Card>
      </div>
    </div>
  );
};

export default GroupPolicy;
